import { createAsyncThunk } from '@reduxjs/toolkit';
import { DownloadInvoice } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { GetDownloadInvoice } from './interface';

export const getDownloadInvoice = createAsyncThunk(
  'downloadInvoice/getDownloadInvoice',
  async ({ id }: GetDownloadInvoice, { rejectWithValue }) => {
    try {
      const response = await DownloadInvoice.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);